import styled from 'styled-components';

export const WrapperForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .linha-filtros {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 1rem;
  }

  .field-date {
    flex: 0 1 230px;
    min-width: 220px;
  }

  .field-autocomplete {
    flex: 1 1 260px;
    min-width: 220px;
  }

  .row-botoes {
    width: auto;
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    gap: 1rem;
    justify-content: flex-start;
    align-items: center;
    margin-top: 0;
  }

  @media (max-width: 768px) {
    .field-date,
    .field-autocomplete {
      flex: unset;
      width: 100%;
    }

    .row-botoes {
      width: 100%;
      margin-top: 0;
    }
  }
`;
